require('../../modules/es7.array.includes');
module.exports = require('../../modules/_core').Array.includes;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/array/includes.js
// module id = 478
// module chunks = 0